import React, { useEffect, useState } from 'react';

import { Search as SearchIcon } from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { AppAction } from 'src/actions/app.action';
import { OrderAction } from 'src/actions/order.action';
import * as XLSX from 'xlsx';

import {
  CONFIRM_TYPES,
  DEFAULT_ROW_PER_PAGE,
  DEFAULT_HOMEPAGE_ROW_PER_PAGE,
  ROW_PER_PAGE_OPTIONS,
  SIM_TYPE_LIST,
  SIM_TYPE_LIST_OBJ,
} from 'src/utils/constants';

import {
  Box,
  Button,
  Card,
  CardContent,
  InputAdornment,
  SvgIcon,
  TextField,
  Select,
  MenuItem,
} from '@material-ui/core';

import ReactSelect from 'react-select';

import CreateEditDialog from './CreateEditDialog';
import ErrorDialog from './ErrorDialog';

import { saveAs } from 'file-saver';

import PerfectScrollbar from 'react-perfect-scrollbar';
import { Settings, Download, Upload, Cached, ReportProblem } from '@material-ui/icons';

import {
  DatePicker,
  LocalizationProvider,
} from '@mui/x-date-pickers';

import moment from 'moment';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocationAction } from 'src/actions/location.action';

const OrderToolbar = (props) => {
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false);
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const [preview, setPreview] = useState(false);
  const [assign, setAssign] = useState(false);
  const { info, permissions, role } = useSelector(state => state.profile);
  const { errorRows } = useSelector(state => state.order);
  const { isLoading } = useSelector(state => state.app);

  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [wards, setWards] = useState([]);

  const danhSachLoaiSim = SIM_TYPE_LIST_OBJ;

  const fileInput = React.useRef();

  const [values, setValues] = useState({
    so_dien_thoai: "",
    so_dien_thoai_khach_dat: "",
    trang_thai: "",
    province: "",
    province_name: "",
    district: "",
    district_name: "",
    ward: "",
    ward_name: "",
    province1: "",
    district1: "",
    ward1: "",
    address: "",
  });

  useEffect(() => {
    if (errorRows) {
      console.log("errorRows", errorRows, Object.entries(errorRows).length, Object.values(errorRows).length, Object.keys(errorRows).length);
    }
  }, [errorRows])

  useEffect(() => {
    async function fetchData() {
        try {
            let getProvinces = await dispatch(LocationAction.getProvinces());
            console.log(getProvinces);
            setProvinces(getProvinces);
        } catch (error) {
            console.error(error);
        }
    }

    // fetchData();
    
    const today = new Date();

    const payload = {
      page: 0,
      limit: DEFAULT_ROW_PER_PAGE,
      so_dien_thoai: "",
      so_dien_thoai_khach_dat: "",
      trang_thai: "",
      province: "",
      province_name: "",
      district: "",
      district_name: "",
      ward: "",
      ward_name: "",
      province1: "",
      district1: "",
      ward1: "",
      address: "",
    };
    dispatch(OrderAction.updateFilter(payload));
  }, []);

  useEffect(() => {
      async function fetchData() {
          try {
              setValues({ 
                  ...values, 
                  ward: "-99", 
                  ward_name: "", 
              });
              setWards([]);
              let getWards = await dispatch(LocationAction.getWardsByDistrict(values.district));
              console.log(getWards);
              setWards(getWards);
          } catch (error) {
              console.error(error);
          }
      }

      // fetchData();
  }, [values.province, values.district])

  useEffect(() => {
      async function fetchData() {
          try {
              setValues({ 
                  ...values, 
                  district: "-99",
                  district_name: "", 
              });
              setDistricts([]);
              let getDistricts = await dispatch(LocationAction.getDistrictsByProvince(values.province));
              console.log(getDistricts);
              setDistricts(getDistricts);
          } catch (error) {
              console.error(error);
          }
      }

      // fetchData();
  }, [values.province])

  const handleClickOpenErrorDialog = () => {
    setOpenErrorDialog(true);
  };

  const handleCloseErrorDialog = () => {
    setOpenErrorDialog(false);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClosePreview = () => {
    fileInput.current.value = null;
    setPreview(false)
  }

  const handleCloseAssign = () => {
    fileInput.current.value = null;
    setAssign(false)
  }

  const handleOpenAssign = () => {
    dispatch(OrderAction.countAssign())
    setAssign(true)
  }

  const handleClose = () => {
    setOpen(false);
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      onLookup();
    }
  };

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const handleChange1 = (key, value, key1 = null, value1 = null) => {
      if (key1 && value1) {
        setValues({ 
              ...values, 
              [key]: value,
              [key1]: value1,
          });
      } else {
        setValues({ 
              ...values, 
              [key]: value 
          });
      }
  };

  const onLookup = () => {
    const payload = {
      page: 'no_update',
      limit: 'no_update',
      so_dien_thoai: values.so_dien_thoai,
      so_dien_thoai_khach_dat: values.so_dien_thoai_khach_dat,
      trang_thai: values.trang_thai,
      province: values.province,
      province_name: values.province_name,
      district: values.district,
      district_name: values.district_name,
      ward: values.ward,
      ward_name: values.ward_name,
      province1: values.province1,
      district1: values.district1,
      ward1: values.ward1,
      address: values.address,
    };
    dispatch(OrderAction.updateFilter(payload));
    dispatch(OrderAction.list())
  };

  const handleImportFile = (e) => {
    e.preventDefault();
    dispatch(AppAction.appLoading(true))
    const files = e.target.files, f = files[0];
    const reader = new FileReader();
    reader.onload = function (e) {
      let data = e.target.result;
      let readedData = XLSX.read(data, { type: 'binary' });
      const wsname = readedData.SheetNames[0];
      const ws = readedData.Sheets[wsname];
      /* Convert array to json*/
      const dataParse = XLSX.utils.sheet_to_json(ws, { header: 1 });
      const headerRow = dataParse[0]; // đây là dòng tiêu đề
      const dataRows = dataParse.slice(1); // phần dữ liệu thực sự (bỏ tiêu đề)
      const temp = dataRows
      .filter(c => c[0] !== undefined && c[0] !== null && c[0].toString().trim() !== '')
      .map((c) => {
        let product_type = '';
        let ordered_number_type = 0;
        let ordered_so_dien_thoai_co_dau_cham = '';
        let ordered_so_dien_thoai = '';
        let ordered_nha_mang = '';
        let ordered_name = '';
        let quantity = 0;
        let ordered_gia_khach_hang = 0;
        let ordered_price = 0;
        let payment_method = '';
        let trang_thai = '';

        if (c[0]) {
          if (c[0].toUpperCase() === 'SIM SỐ') {
            product_type = 'sim_so';

            if (c[9]) {
              ordered_so_dien_thoai_co_dau_cham = c[9];
              ordered_so_dien_thoai = ordered_so_dien_thoai_co_dau_cham.replace(/\D/g, '');
            }

            if (c[10] && (c[10].toUpperCase() == 'MOBIFONE' || c[10].toUpperCase() == 'VINAPHONE' || c[10].toUpperCase() == 'VIETTEL')) {
              ordered_nha_mang = c[10].toUpperCase();
            }

            if (c[12]) {
              ordered_gia_khach_hang = Number(c[12]);
            }
          } else if (c[0].toUpperCase() === 'SIM DATA') {
            product_type = 'sim_data';

            if (c[9]) {
              ordered_name = c[9];
            }

            if (c[10]) {
              quantity = Number(c[10]);
            }

            if (c[12]) {
              ordered_price = Number(c[12]);
            }
          } else if (c[0].toUpperCase() === 'VOUCHER') {
            product_type = 'voucher';
          }
        }

        if (c[11]) {
          if (c[11].toUpperCase() === 'TRẢ TRƯỚC') {
            ordered_number_type = 1;
          } else if (c[11].toUpperCase() === 'TRẢ SAU') {
            ordered_number_type = 2;
          }
        }

        if (c[13]) {
          if (c[13].toUpperCase() === 'CHUYỂN KHOẢN') {
            payment_method = 'online';
          } else if (c[13].toUpperCase() === 'COD') {
            payment_method = 'cod';
          }
        }

        if (c[16]) {
          if (c[16].toUpperCase() === 'CHƯA GIAO') {
            trang_thai = 'chua_giao';
          } else if (c[16].toUpperCase() === 'ĐANG VẬN CHUYỂN') {
            trang_thai = 'dang_van_chuyen';
          } else if (c[16].toUpperCase() === 'GIAO THÀNH CÔNG') {
            trang_thai = 'giao_thanh_cong';
          } else if (c[16].toUpperCase() === 'ĐƠN HÀNG THẤT LẠC') {
            trang_thai = 'don_hang_that_lac';
          } else if (c[16].toUpperCase() === 'XỬ LÝ THÀNH CÔNG') {
            trang_thai = 'xu_ly_thanh_cong';
          }
        }

        return {
          ten_file_upload: files[0].name,
          product_type,
          name: c[1],
          note: c[2],
          phone: c[3],
          address: c[4],
          ward_name: c[5],
          district_name: c[6],
          province_name: c[7],
          ma_sim: c[8] ? c[8].toUpperCase() : '',
          ordered_so_dien_thoai_co_dau_cham,
          ordered_so_dien_thoai,
          ordered_nha_mang,
          ordered_name,
          quantity,
          ordered_number_type,
          ordered_gia_khach_hang,
          ordered_price,
          payment_method,
          phi: c[14],
          thuc_thu: c[15],
          trang_thai,
          ghi_chu_don_hang: c[17],
        };
      });
      let temp1 = {}
      if (temp != null && temp.length > 0) {
        let i = 0
        temp.forEach(function (element) {
          temp1[i] = element
          i++;
        })
      }
      temp1 = Object.values(temp1)
      console.log(temp1);
      dispatch(OrderAction.saveDataUpload(temp1));
    };
    reader.readAsBinaryString(f)
  }

  const exportExcel = async () => {
    dispatch(AppAction.appLoading(true))
    try {
      const payload = {
        page: 0,
        limit: 9999999999,
        so_dien_thoai: values.so_dien_thoai,
        so_dien_thoai_khach_dat: values.so_dien_thoai_khach_dat,
        trang_thai: values.trang_thai,
        province: values.province,
        province_name: values.province_name,
        district: values.district,
        district_name: values.district_name,
        ward: values.ward,
        ward_name: values.ward_name,
        province1: values.province1,
        district1: values.district1,
        ward1: values.ward1,
        address: values.address,
      };
      dispatch(OrderAction.updateFilter(payload));
      const response = await dispatch(OrderAction.list());

      let data = [];
      
      data = [
        [
          'Sản phẩm',
          'Tên KH',
          'Ghi chú KH',
          'SĐT đặt hàng',
          'Địa chỉ chi tiết', 
          'Phường/xã', 
          'Quận/huyện', 
          'Tỉnh/thành', 
          'ID đơn hàng',
          'Mã SIM',
          'SĐT/Tên SP',
          'Nhà mạng/Số lượng',
          'Loại thuê bao',
          'Giá',
          'Hình thức thanh toán',
          'Phí',
          'Thực thu',
          'Trạng thái',
          'Ghi chú đơn hàng',
          'Thời điểm tạo đơn',
        ],
      ];

      if (typeof response !== 'undefined' && response != null && typeof response.data !== 'undefined' && response.data != null && typeof response.data.values !== 'undefined' && response.data.values != null && response.data.values.length > 0) {
        console.log(response);
        let count = 1;
        response.data.values.forEach((element) => {
          let product_type = "";
          let sdt_hoac_ten_sp = "";
          let nha_mang_hoac_so_luong = "";
          let gia = "";
          let payment_method = "";
          let trang_thai = "";

          if (element.product_type == 'sim_so') {
            product_type = "Sim số";
            sdt_hoac_ten_sp = element.ordered_so_dien_thoai_co_dau_cham;
            nha_mang_hoac_so_luong = element.ordered_nha_mang;
            gia = Number(element.ordered_gia_khach_hang_khuyen_mai) > 0 && Number(element.ordered_gia_khach_hang_khuyen_mai) < Number(element.ordered_gia_khach_hang) ? element.ordered_gia_khach_hang_khuyen_mai : element.ordered_gia_khach_hang;
          } else if (element.product_type == 'sim_data') {
            product_type = "Sim data";
            sdt_hoac_ten_sp = element.ordered_name;
            nha_mang_hoac_so_luong = element.quantity;
            gia = Number(element.ordered_price_new) > 0 && Number(element.ordered_price_new) < Number(element.ordered_price) ? element.ordered_price_new : element.ordered_price
          } else if (element.product_type == 'voucher') {
            product_type = "Voucher";
          }

          if (element.trang_thai == 'chua_giao') {
            trang_thai = "Chưa giao";
          } else if (element.trang_thai == 'dang_van_chuyen') {
            trang_thai = "Đang vận chuyển";
          } else if (element.trang_thai == 'giao_thanh_cong') {
            trang_thai = "Giao thành công";
          } else if (element.trang_thai == 'don_hang_that_lac') {
            trang_thai = "Đơn hàng thất lạc";
          } else if (element.trang_thai == 'xu_ly_thanh_cong') {
            trang_thai = "Xử lý thành công";
          }

          if (element.payment_method == "online") payment_method = "Chuyển khoản";
          else payment_method = "COD";

          data.push([
            product_type,
            element.name,
            element.note,
            element.phone,
            element.address,
            element.ward_name,
            element.district_name,
            element.province_name,
            element.id,
            element.ma_sim ? element.ma_sim.toUpperCase() : "",
            sdt_hoac_ten_sp,
            nha_mang_hoac_so_luong,
            element.ordered_number_type == 1 ? 'TRẢ TRƯỚC' : (element.ordered_number_type == 2 ? 'TRẢ SAU' : ''),
            gia,
            payment_method,
            element.phi,
            element.thuc_thu,
            trang_thai,
            element.ghi_chu_don_hang,
            moment(element.createdAt).format('DD-MM-YYYY HH:mm:ss'),
          ])

          count++;
        })

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet(data);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Danh sách đơn hàng');
        
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, `Danh-sach-don-hang-${(new Date()).toLocaleDateString("en-CA").replace(/_/g, "-")}.xlsx`);
      }

      dispatch(AppAction.appLoading(false))
    } catch (error) {
      if (typeof error.code !== 'undefined' && typeof error.msg !== 'undefined') alert("[Lỗi]\n"+error.msg)
    }
  };

  const setColor = (value) => {
    if (value == 'da_thanh_toan') return 'green';
    else if (value == 'chua_thanh_toan') return 'red';
    else if (value == 'chua_giao') return 'red';
    else if (value == 'dang_van_chuyen') return 'orange';
    else if (value == 'giao_thanh_cong') return 'green';
    else if (value == 'don_hang_that_lac') return 'red';
    else if (value == 'xu_ly_thanh_cong') return 'green';
    else if (value == 'online') return 'green';
    else if (value == 'cod') return 'blue';
    else if (value == 'MOBIFONE') return 'green';
    else if (value == 'VINAPHONE') return 'blue';
    else if (value == 'VIETTEL') return 'red';
    else return 'black';
  };

  return (
    <Box {...props}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end'
        }}
      >
        <input
          ref={fileInput}
          type="file"
          onChange={(e) => handleImportFile(e)}
          style={{ display: 'none' }}
        />
      </Box>
      <Box sx={{ mt: 3 }}>
        <Card className="filter_card">
          <CardContent>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <PerfectScrollbar>
                <Box sx={{ maxWidth: '100%' }}>
                  <TextField
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SvgIcon
                            fontSize="small"
                            color="action"
                            >
                            <SearchIcon />
                          </SvgIcon>
                        </InputAdornment>
                      )
                    }}
                    name="so_dien_thoai"
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    value={values.so_dien_thoai}
                    placeholder="SĐT khách hàng"
                    variant="outlined"
                    style={{ height: 56, marginTop: 6, width: "200px", marginLeft: 0 }}
                  />
                  <TextField
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SvgIcon
                            fontSize="small"
                            color="action"
                            >
                            <SearchIcon />
                          </SvgIcon>
                        </InputAdornment>
                      )
                    }}
                    name="so_dien_thoai_khach_dat"
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    value={values.so_dien_thoai_khach_dat}
                    placeholder="Số sim"
                    variant="outlined"
                    style={{ height: 56, marginTop: 6, width: "200px", marginLeft: 15 }}
                  />
                  <Select
                    style={{ height: 56, marginTop: 6, width: "200px", marginLeft: 15 }}
                    name="trang_thai"
                    value={values.trang_thai || -99}
                    onChange={handleChange}
                    variant="outlined"
                    startAdornment={(
                      <InputAdornment position="start">
                        <SvgIcon fontSize="small" color="action">
                          <SearchIcon />
                        </SvgIcon>
                      </InputAdornment>
                    )}
                  >
                    <MenuItem value="-99">Trạng thái...</MenuItem>
                    <MenuItem style={{ color: setColor('chua_giao') }} value="chua_giao">Chưa giao</MenuItem>
                    <MenuItem style={{ color: setColor('dang_van_chuyen') }} value="dang_van_chuyen">Đang vận chuyển</MenuItem>
                    <MenuItem style={{ color: setColor('giao_thanh_cong') }} value="giao_thanh_cong">Giao thành công</MenuItem>
                    <MenuItem style={{ color: setColor('don_hang_that_lac') }} value="don_hang_that_lac">Đơn hàng thất lạc</MenuItem>
                    <MenuItem style={{ color: setColor('xu_ly_thanh_cong') }} value="xu_ly_thanh_cong">Xử lý thành công</MenuItem>
                  </Select>
                  {/* <div style={{ width: '100%', zIndex: '10', marginTop: 0 }} className="full-width-select">
                      <ReactSelect
                          classNamePrefix="nt-select"
                          menuPortalTarget={document.body}
                          styles={{
                              menuPortal: base => ({
                                  ...base,
                                  zIndex: 999999,
                              }),
                              control: (provided) => ({
                                  ...provided,
                                  height: 37,
                                  fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                              }),
                              option: (provided) => ({
                                  ...provided,
                                  fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                              }),
                          }}
                          options={[
                              { code: '-99', name: 'Chọn tỉnh/thành' },
                              ...provinces
                          ]}
                          getOptionLabel={(item) => `${item.name}`}
                          placeholder={values.province_name || "Chọn tỉnh/thành..."}
                          components={{
                              DropdownIndicator: () => <SearchIcon size={16} color="action" />,
                              IndicatorSeparator: null,
                          }}
                          value={values.province || null}
                          onChange={(newValue) => {
                              handleChange1('province', newValue.code, 'province_name', newValue.name);
                          }}
                          isSearchable
                      />
                  </div> */}
                  {/* <div style={{ width: '100%', zIndex: '10', marginTop: 0 }} className="full-width-select">
                      <ReactSelect
                          classNamePrefix="nt-select"
                          menuPortalTarget={document.body}
                          styles={{
                              menuPortal: base => ({
                                  ...base,
                                  zIndex: 999999,
                              }),
                              control: (provided) => ({
                                  ...provided,
                                  height: 37,
                                  fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                              }),
                              option: (provided) => ({
                                  ...provided,
                                  fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                              }),
                          }}
                          options={[
                              { code: '-99', name: 'Chọn quận/huyện' },
                              ...districts
                          ]}
                          getOptionLabel={(item) => `${item.name}`}
                          placeholder={values.district_name || "Chọn quận/huyện..."}
                          components={{
                              DropdownIndicator: () => <SearchIcon size={16} color="action" />,
                              IndicatorSeparator: null,
                          }}
                          value={values.district || null}
                          onChange={(newValue) => {
                              handleChange1('district', newValue.code, 'district_name', newValue.name);
                          }}
                          isSearchable
                      />
                  </div> */}
                  {/* <div style={{ width: '100%', zIndex: '10', marginTop: 0 }} className="full-width-select">
                      <ReactSelect
                          classNamePrefix="nt-select"
                          menuPortalTarget={document.body}
                          styles={{
                              menuPortal: base => ({
                                  ...base,
                                  zIndex: 999999,
                              }),
                              control: (provided) => ({
                                  ...provided,
                                  height: 37,
                                  fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                              }),
                              option: (provided) => ({
                                  ...provided,
                                  fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                              }),
                          }}
                          options={[
                              { code: '-99', name: 'Chọn phường/xã' },
                              ...wards
                          ]}
                          getOptionLabel={(item) => `${item.name}`}
                          placeholder={values.ward_name || "Chọn phường/xã..."}
                          components={{
                              DropdownIndicator: () => <SearchIcon size={16} color="action" />,
                              IndicatorSeparator: null,
                          }}
                          value={values.ward || null}
                          onChange={(newValue) => {
                              handleChange1('ward', newValue.code, 'ward_name', newValue.name);
                          }}
                          isSearchable
                      />
                  </div> */}
                  <TextField
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SvgIcon
                            fontSize="small"
                            color="action"
                            >
                            <SearchIcon />
                          </SvgIcon>
                        </InputAdornment>
                      )
                    }}
                    name="province1"
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    value={values.province1}
                    placeholder="Tỉnh/thành"
                    variant="outlined"
                    style={{ height: 56, marginTop: 6, width: "200px", marginLeft: 15 }}
                  />
                  <TextField
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SvgIcon
                            fontSize="small"
                            color="action"
                            >
                            <SearchIcon />
                          </SvgIcon>
                        </InputAdornment>
                      )
                    }}
                    name="district1"
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    value={values.district1}
                    placeholder="Quận/huyện"
                    variant="outlined"
                    style={{ height: 56, marginTop: 6, width: "200px", marginLeft: 15 }}
                  />
                  <TextField
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SvgIcon
                            fontSize="small"
                            color="action"
                            >
                            <SearchIcon />
                          </SvgIcon>
                        </InputAdornment>
                      )
                    }}
                    name="ward1"
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    value={values.ward1}
                    placeholder="Phường/xã"
                    variant="outlined"
                    style={{ height: 56, marginTop: 6, width: "200px", marginLeft: 15 }}
                  />
                  <TextField
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SvgIcon
                            fontSize="small"
                            color="action"
                            >
                            <SearchIcon />
                          </SvgIcon>
                        </InputAdornment>
                      )
                    }}
                    name="address"
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    value={values.address}
                    placeholder="Địa chỉ chi tiết"
                    variant="outlined"
                    style={{ height: 56, marginTop: 6, width: "200px", marginLeft: 15 }}
                  />
                </Box>
              </PerfectScrollbar>
            </LocalizationProvider>
          </CardContent>
        </Card>
        <Card>
          <div className='functional-btn-container' style={{width: '250px', margin: 'auto'}}>
            {errorRows && Object.entries(errorRows).length > 0 && <Button
              color="primary"
              variant="contained"
              onClick={handleClickOpenErrorDialog}
              style={{ height: '20px', padding: 0, marginTop: 0, width: '20px', minWidth: '20px', marginRight: '5px', backgroundColor: 'transparent', fontWeight: 'normal', fontSize: '20px' }}
              >
              <ReportProblem style={{ color: "red" }} />
            </Button>}
            <Button
              color="primary"
              variant="contained"
              onClick={() => window.open('https://docs.google.com/spreadsheets/d/1OcN1ImQzgIliLAMdGjZASeaaG42mi3sN', '_blank', 'width=800,height=600')}
              style={{ height: '20px', padding: 0, marginTop: 0, width: "150px", minWidth: '20px', marginLeft: '0', backgroundColor: 'orange', fontWeight: 'normal' }}
              >
              Form mẫu
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={() => fileInput.current.click()}
              style={{ height: '20px', padding: 0, marginTop: 0, width: '20px', minWidth: '20px', marginLeft: '5px', backgroundColor: 'transparent', fontWeight: 'normal', fontSize: '20px' }}
              >
              <Upload style={{ color: "#2ecc71" }} />
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={() => exportExcel()}
              style={{ height: '20px', padding: 0, marginTop: 0, width: '20px', minWidth: '20px', marginLeft: '5px', backgroundColor: 'transparent', fontWeight: 'normal', fontSize: '20px' }}
              >
              <Download style={{ color: "#3498db" }} />
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={onLookup}
              style={{ background: !isLoading ? 'transparent' : 'url(/static/images/loading.gif) no-repeat center center / contain', height: '20px', padding: 0, marginTop: 0, width: '20px', minWidth: '20px', marginLeft: '5px', backgroundColor: 'transparent', fontWeight: 'normal', fontSize: '20px' }}
              >
              {!isLoading ? <Cached style={{ color: "#3498db" }} /> : ''}
            </Button>
          </div>
        </Card>
      </Box>
      <CreateEditDialog open={open} handleClose={handleClose} type={"CREATE"} />
      <ErrorDialog open={openErrorDialog} handleClose={handleCloseErrorDialog} type={"CREATE"} />
    </Box>
  )
};

export default OrderToolbar;
